import { render } from "./PMemberCenter.vue?vue&type=template&id=16322bd2&scoped=true"
import script from "./PMemberCenter.vue?vue&type=script&lang=js"
export * from "./PMemberCenter.vue?vue&type=script&lang=js"

import "./PMemberCenter.vue?vue&type=style&index=0&id=16322bd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16322bd2"]])

export default __exports__